import React, { FC, ReactNode, useEffect, useState } from "react";
import {
  Box,
  Card,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { usePageStore } from "@/hooks/usePageStore";
import SiteOfficeHoursPage from "@/pages/siteOfficeHours";

interface MenuItem {
  key: string;
  label: string;
  icon: ReactNode;
  content: ReactNode;
}

const menuItems: MenuItem[] = [
  {
    key: "site-office-hours",
    label: "Site Office Hours & Closure",
    icon: <AccessTimeOutlinedIcon fontSize="small" />,
    content: <SiteOfficeHoursPage />,
  },
];

const SettingsPage: FC = () => {
  const { setPageTitle } = usePageStore();
  const [selectedKey, setSelectedKey] = useState(menuItems[0].key);

  useEffect(() => {
    setPageTitle("Settings");
  }, []);

  const selectedItem = menuItems.find((item) => item.key === selectedKey)!;

  return (
    <Box sx={{ display: "flex", gap: 0, alignItems: "flex-start", backgroundColor: '#fff', borderRadius: "8px" }}>
      <Card sx={{ width: "230", flexShrink: 0 }} elevation={0} >
        <List sx={{ p: 2, width: "100%" }}>
          {menuItems.map((item) => (
            <ListItemButton
              key={item.key}
              selected={item.key === selectedKey}
              onClick={() => setSelectedKey(item.key)}
              sx={{
                borderRadius: "4px",
                width: "100%",
                "&.Mui-selected": {
                  backgroundColor: "primary.50",
                  color: "primary.main",
                  "& .MuiListItemIcon-root": { color: "primary.main" },
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{ variant: "bodySmall" }}
              />
            </ListItemButton>
          ))}
        </List>
      </Card>

      <Box sx={{ flex: 1, minWidth: 0, borderLeft: 1, mt: 2, mb: 2, borderColor: "#CDD9E9" }}>{selectedItem.content}</Box>
    </Box>
  );
};

export default SettingsPage;
